import {
  Box,
  Container,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import {
  DiscordLogoIcon,
  EnvelopeIcon,
  GithubLogoIcon,
  LinkedinLogoIcon,
  TelegramLogoIcon,
} from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { PAGE_LIST } from "../../enums/pageEnums";
import { SOCIAL_LINKS } from "../../enums/socialsEnums";
import { copyToClipboard } from "../helpers/clipboardHelper";

// LINKS array removed in favor of SOCIAL_LINKS enum

export const Footer = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        borderTop: `1px solid ${theme.palette.divider}`,
        background: theme.palette.background.paper,
      }}
    >
      <Container maxWidth="lg">
        <Stack alignItems="center" spacing={4}>
          <Stack alignItems="center" spacing={1}>
            <Typography
              variant="h4"
              component="div"
              color="primary"
              fontWeight={800}
              onClick={() => navigate("/")}
              sx={{ cursor: "pointer", letterSpacing: "-0.02em" }}
            >
              &lt;/&gt; dev-jenmar.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Building digital experiences that matter.
            </Typography>
          </Stack>

          <Stack direction="row" gap={3}>
            {PAGE_LIST.map((page) => (
              <Typography
                key={page.name}
                variant="body2"
                onClick={() => navigate(page.path)}
                fontWeight={500}
                sx={{
                  cursor: "pointer",
                  color: "text.secondary",
                  transition: "color 0.2s",
                  "&:hover": { color: "text.primary" },
                }}
              >
                {page.name}
              </Typography>
            ))}
          </Stack>

          <Stack direction="row" gap={1}>
            {SOCIAL_LINKS.map((item, index) => (
              <Tooltip title={item.title} key={index}>
                <IconButton
                  onClick={() => {
                    if (item.title === "Email") {
                      copyToClipboard(item.value, "Email copied to clipboard!");
                    } else {
                      window.open(item.path, "_blank");
                    }
                  }}
                  sx={{
                    color: "primary.main",
                    "&:hover": {
                      background: theme.palette.action.hover,
                      transform: "translateY(-2px)",
                      transition: "all 0.2s",
                    },
                  }}
                >
                  <item.icon size={24} />
                </IconButton>
              </Tooltip>
            ))}
          </Stack>

          <Typography variant="caption" color="text.secondary">
            © {new Date().getFullYear()} Jenmar Macario. All rights reserved.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};
